export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.users.index(payload);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function updateStatus({commit}, payload) {
  const response = await this.$adminRepositories.users.updateStatus(payload.id, payload);
  return response;
}

export async function deleteUserById({dispatch}, payload) {
  const response = await this.$adminRepositories.users.delete(payload.id);
  return response;
}

export async function findUserById({commit}, payload) {
  return await this.$adminRepositories.users.show(payload);
}

export async function bridgeLoginByUserId(_, payload) {
  return await this.$adminRepositories.users.bridgeLoginByUserId(payload);
}

export async function getFilterLandings({commit}, payload = {}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.users.getFilterLandings(payload);

  if (!errResponse) {
    commit('setFilterLandings', responseData.data)
  }
}
